import * as ACTION from './constants';
import { arrayMerge } from '../../utils';

const initialState = {
  classes: [],
  draftClasses: [],
  coachingClasses: [],
  filters: [],
  isLoading: false,
  isFilterLoading: false,
  query: '',
  totalCount: null
};

export default function reducers(state = initialState, action) {
  switch(action.type) {
    case ACTION.CLASS_BASE:
      return {...initialState};
    case ACTION.CLASS_QUERY:
      return {...initialState,
        isLoading: true
      };
    case ACTION.LIBRARY_LOADING:
      return {...state,
        isLoading: true
      };
    case ACTION.LIBRARY_LOADED:
      const classKey = action.draftClasses ? 'draftClasses' : action.coachingClasses ? 'coachingClasses' :'classes';
      return {...state,
        isLoading: false,
        [classKey]: arrayMerge(state[classKey], action[classKey]),
        totalCount: action.totalCount,
        query: action.query
      };
    case ACTION.FILTER_LOADING:
      return {...state,
        isFilterLoading: true
      };
    case ACTION.FILTER_LOADED:
      return {...state,
        isFilterLoading: false,
        filters: action.filters
      };
    default:
      return state;
  }
}
